import { api } from "@/lib/api";
import { VehicleMakeInput } from "@/types/vehicleMake.types";

export const makeService = {
  async getAllMakes() {
    const response = await api.get("/vehicleMake");
    // console.log(response.data);
    return response.data.data;
  },

  async createMake(make: VehicleMakeInput) {
    const response = await api.post("/vehicleMake", make);
    return response.data.data;
  },

  async deleteMake(id: string) {
    const response = await api.delete(`/vehicleMake/${id}`);
    return response.data.data;
  },
};
